import React from 'react'
import { Button } from 'lib/ui/components'
import { Modal } from 'components/Modal'
import { ModalContent, ModalGlobalStyle, Image } from './styled'
import { Avatar } from 'components/ProductSelector'
import { Price } from 'lib/shared/components'
import { DEFAULT_CURRENCY_CODE } from 'lib/core/resources/constants'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser'

interface Props {
  isOpen: boolean
  setModalOpen: (param: boolean) => void
  promoSubscriptionFrequency: number
  promotionValue: any
  promotionalPacks: number
  promoSubTotalPieces: number
  productImage: string
}

export const PerfectProductModal = ({ isOpen, setModalOpen, promoSubscriptionFrequency, promotionValue, promotionalPacks, promoSubTotalPieces, productImage }: Props) => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.PPQ_SUCCESS_MODAL,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      if (attribs.id === 'trigger') {
        return <Button onClick={() => setModalOpen(false)}>{domToReact(children, options)}</Button>
      }

      if (attribs.id === 'image') {
        return <Image src={productImage} onClick={() => setModalOpen(false)} />
      }

      if (attribs.id === 'frequency') {
        return <>{promoSubscriptionFrequency}</>
      }

      if (attribs.id === 'price') {
        return <Price currency={DEFAULT_CURRENCY_CODE} value={promotionValue} />
      }

      if (attribs.id === 'packs') {
        return <>{promotionalPacks} {promotionalPacks > 1 ? 'packs' : 'pack'}</>
      }

      if (attribs.id === 'pieces') {
        return <>{promoSubTotalPieces}</>
      }
    }
  }

  return (
    <Modal isOpen={isOpen} type='normal' handleCloseModal={() => setModalOpen(false)} isCloseThin>
      <ModalContent>
        <Avatar isResults />
        {staticBlock.content && (
          <div>
            {parse(staticBlock.content, options)}
          </div>
        )}
      </ModalContent>
      <ModalGlobalStyle />
    </Modal>
  )
}
